import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { photos } from '../data/photos';
import Lightbox from './Lightbox';
import './Gallery.css';

// Every few tiles gets a bold "featured" span to create an asymmetric,
// editorial mosaic instead of a uniform grid.
const getTileSize = (index) => {
  if (index % 7 === 0) return 'tile-large';
  if (index % 5 === 0) return 'tile-tall';
  if (index % 3 === 0) return 'tile-wide';
  return 'tile-regular';
};

const tileVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (delay) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay, ease: [0.16, 1, 0.3, 1] },
  }),
};

const Gallery = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <section id="gallery" className="section gallery">
      <h2 className="section-heading">My Portfolio</h2>

      <div className="gallery-grid">
        {photos.map((photo, i) => (
          <motion.button
            key={photo.id}
            type="button"
            className={`gallery-tile ${getTileSize(i)}`}
            onClick={() => setActiveIndex(i)}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-10% 0px' }}
            custom={(i % 6) * 0.06}
            variants={tileVariants}
            whileHover="hover"
          >
            <motion.img
              src={photo.src}
              alt={photo.alt}
              loading="lazy"
              variants={{ hover: { scale: 1.06 } }}
              transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
            />
            <motion.div
              className="gallery-tile-overlay"
              variants={{ hover: { opacity: 1 } }}
              initial={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              <span className="gallery-tile-index">
                {String(i + 1).padStart(2, '0')}
              </span>
            </motion.div>
          </motion.button>
        ))}
      </div>

      <Lightbox
        photos={photos}
        index={activeIndex}
        onClose={() => setActiveIndex(null)}
        onNavigate={setActiveIndex}
      />
    </section>
  );
};

export default Gallery;
